import React from 'react';
import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import { useSaveToFavorite } from 'components/useSaveToFavorite';
import ShareWithDropdown from 'components/ShareWithDropdown';
import { shouldShowContentfulTools } from 'containers/Auth/utils';
import AdminBtn from 'components/ResourcePageLeftPanel/AdminBtn';
import ShareIcon from 'components/ShareWithDropdown/images/share.svg';
import { SeriesHeartButton } from './main/SeriesHeartButton';

const useStyles = makeStyles(() => ({
  rightActionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  editButton: {
    marginBottom: 0,
    marginLeft: 16,
  },
}));

export const SeriesActionButtons = ({
  item,
  allowSignIn,
  type,
  resourcePathname,
  showEditSeriesAction,
  renderHeartButton,
  showShareAction = true,
}) => {
  const resourceId = _get(item, 'sys.id');

  const { saved, handleSave } = useSaveToFavorite({
    item: { ...item.fields, id: resourceId },
    type,
  });
  const classes = useStyles();

  const profile = useSelector(state => state.firebase.profile);
  const showEditSeriesButton =
    showEditSeriesAction && shouldShowContentfulTools(profile);

  return (
    <div className={classes.rightActionsContainer}>
      {renderHeartButton?.({ id: resourceId, saved, handleSave }) || (
        <SeriesHeartButton saved={saved} handleSave={handleSave} />
      )}
      {allowSignIn && showShareAction && (
        <ShareWithDropdown
          id={_get(item, 'sys.id')}
          name={_get(item, 'fields.title') || _get(item, 'fields.name')}
          type={type}
          iconOnly
          url={
            resourcePathname && `${window.location.origin}${resourcePathname}`
          }
          copyLinkSource="series"
          customIcon={<img src={ShareIcon} alt="Share" />}
        />
      )}
      {showEditSeriesButton && (
        <AdminBtn
          id={resourceId}
          tooltipId={`${resourceId}-tooltip`}
          btnClassName={classes.editButton}
        />
      )}
    </div>
  );
};
